/** @format */

import React from 'react';
import { Link } from 'react-router-dom';

export const Header = () => {
	return (
		<header>
			<div className='container'>
				<div className='inner-content'>
					<div className='brand'>
						<Link to='/Add'>Search </Link>
					</div>

					<ul className='nav-links'>
						<li>
							<Link to='/favouritemovies'>Favourite movies</Link>
						</li>

						<li>
							<Link to='/watched'>To Watch List </Link>
						</li>
					</ul>
				</div>
			</div>
		</header>
	);
};
export default Header;
